/* eslint-disable camelcase */
import getConfig from "next/config";
import {
    ApiArticleCompanySponsor,
    ApiArticleWriter,
} from "interfaces/api/apiInterfaces";

const getSponsorLogo = (path?: string): string => {
    if (!path) {
        return "";
    }
    const { publicRuntimeConfig: { pilboxHost, staticCmsAssetHost } } = getConfig();
    const resized = new URL(pilboxHost);
    resized.search = new URLSearchParams({
        url: `${staticCmsAssetHost}/${path}`,
        w: "202",
        filter: "antialias",
        mode: "fill",
        background: "fff",
        opt: "1",
        prog: "1",
        q: "keep"
    }).toString();
    return resized.toString();
};

const getAuthorLogo = (path?: string): string => {
    if (!path) {
        return "";
    }
    const { publicRuntimeConfig: { pilboxHost } } = getConfig();
    const resized = new URL(pilboxHost);
    resized.search = new URLSearchParams({
        url: path,
        h: "120",
        w: "120",
        filter: "antialias",
        mode: "crop",
        pos: "top",
        opt: "1",
        prog: "1",
        q: "keep"
    }).toString();
    return resized.toString();
};

type LogoSrcRequestProps = {
    sponsor?: ApiArticleCompanySponsor;
    writer?: ApiArticleWriter;
};

export const getLogoSrc = ({ sponsor, writer }: LogoSrcRequestProps): string => {
    if (sponsor?.id) {
        return getSponsorLogo(sponsor?.logoImage);
    }

    return getAuthorLogo(writer?.headshot?.url);
};

export type SnowplowPropsRequestProps = {
    articleId: string;
    companyId?: string;
    tileOrder: number;
    trackingLocation?: string;
};

const getBaseSnowplowProps = ({
    articleId,
    companyId,
    tileOrder,
    trackingLocation,
}: SnowplowPropsRequestProps) => ({
    sp_tile_company_id: companyId,
    sp_tile_entity_id: articleId,
    sp_tile_location: trackingLocation,
    sp_tile_order: tileOrder,
    sp_tile_type: "article",
});

export const getImpressionProps = (props: SnowplowPropsRequestProps) => {
    const { trackingLocation } = props;
    if (!trackingLocation) {
        return {};
    }
    const baseProps = getBaseSnowplowProps(props);
    return {
        "data-tracking-event-type": "impression",
        "data-tracking-props": JSON.stringify({
            ...baseProps,
            sp_impression_component: "tile",
            sp_impression_position: "main",
            sp_impression_tile_type: "article",
        }),
    };
};

export type SnowplowRequestEventProps = {
    linkText?: string;
} & SnowplowPropsRequestProps

export const getClickEventProps = (props: SnowplowRequestEventProps) => {
    const { linkText, ...restProps } = props;
    const { trackingLocation } = props;
    const baseProps = getBaseSnowplowProps(restProps);
    return {
        ...baseProps,
        sp_click_component: "tile",
        sp_click_component_tile_type: "article",
        sp_click_link_text: linkText || null,
        sp_click_position: trackingLocation,
        sp_click_target_page_section: "profile",
    };
};
